import { Component, Inject, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: 'time-in-form-component',
    template: `
        <mat-form-field appearance="fill">
            <mat-select [(value)]="scanStation.scanStationObj.dataToAdd[field.field_slug]"
                        placeholder="Select Time" (selectionChange)="onTimeChange($event)"
                        [disabled]="scanStation.isViewMode()">
                <mat-option *ngFor="let time of times" [value]="time">
                    {{ time }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <style>
            time-in-form-component .mat-form-field-flex {
                padding-top: 0px !important;
            }
        </style>
    `,
    styleUrls: ['angular-blocworx/components/fields/time/time-in-form.component.scss'],

})
export class TimeInFormComponent implements OnInit {
    @Input() scanStation;
    @Input() field: any;
    times: string[] = [];

    constructor() {
        // Constructor is empty - inputs aren't available yet
    }

    ngOnInit() {
        // Map timeIntervals values to minute increments
        const intervalMap = {
            'every-1-minute': 1,
            'every-5-minutes': 5,
            'every-15-minutes': 15,
            'every-30-minutes': 30,
            'every-60-minutes': 60
        };

        // Get the interval in minutes, default to 15 if not found
        const intervalMinutes = intervalMap[this.field?.timeIntervals] || 15;

        // Generate times from 00:00 to 23:59 based on the specified interval
        for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 60; j += intervalMinutes) {
                const hour = i < 10 ? "0" + i : "" + i;
                const minute = j < 10 ? "0" + j : "" + j;
                this.times.push(`${hour}:${minute}`);
            }
        }

        if (!this.scanStation.isEditOrViewMode()) {
            let defaultTime: string | null = null;

            if (this.field.defaultTimeMode === 'fixed-value' && this.field.defaultValue && this.field.defaultValue.trim() !== '') {
                // Explicit fixed value
                defaultTime = this.field.defaultValue.trim();
            } else if (this.field.defaultTimeMode === 'current-time') {
                // Round current time down to the nearest interval
                const now = new Date();
                const totalMinutes = now.getHours() * 60 + now.getMinutes();
                const roundedMinutes = Math.floor(totalMinutes / intervalMinutes) * intervalMinutes;
                const h = Math.floor(roundedMinutes / 60);
                const m = roundedMinutes % 60;
                defaultTime = `${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}`;
            } else {
                defaultTime = '08:00';
            }

            if (!this.scanStation.scanStationObj.dataToAdd[this.field.field_slug]) {
                this.scanStation.scanStationObj.dataToAdd[this.field.field_slug] = defaultTime;
            }
        }
    }

    onTimeChange(event: any) {
        this.scanStation.scanStationObj.dataToAdd[this.field.field_slug] = event.value;
        this.scanStation.getRules('no-event', this.field.id, this.field.special_field_key, this.scanStation.scanStationObj.dataToAdd[this.field.field_slug], this.field.fieldIndex, this.field.field_slug);
    }
}
